import React, {useState, useEffect} from 'react';
import '../css/App.css';
import '../css/bootstrap.min.css';
import AlertWindow from '../Alert';
import EditUser from './settings/EditUser';
import Permissions from '../Permissions';
import refreshIcon from '../img/refresh.png';
import settingsIcon from '../img/settings.png';
import bootstrap from 'bootstrap';
import Time from '../Time';
import Members from './Members';
import UsersSettings from './settings/UsersSettings';

class AllUsers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

        allMembers:[],
        userSettings:false,
        profileEdit:false,
        editingUser:0,
        chosenUserName:"",
        chosenUserPermissions:""


    };
    
    this.openCloseAlert = this.openCloseAlert.bind(this);
    this.openCloseSettings = this.openCloseSettings.bind(this);
    this.openCloseProfileEdit = this.openCloseProfileEdit.bind(this);
  }

  openCloseAlert = () =>{
    let alertStatus = this.state.alertWindow;

    if(alertStatus == ""){
      this.setState({alertWindow:<AlertWindow close={this.openCloseAlert} message={""} />})
    }else{
      this.setState({alertWindow:""})
    }

  }

  openCloseProfileEdit = (e) =>{
    let windowStatus = this.state.profileEdit;
    if(windowStatus == false){
      //gets info from the selected user
      let editingUserId = e.target.attributes.userid.value
      let editingUseName = e.target.attributes.username.value
      let editingUserPermissions = e.target.attributes.userpermissions.value
      //sets into the state
      this.setState({editingUser:editingUserId})
      this.setState({chosenUserName:editingUseName})
      this.setState({chosenUserPermissions:editingUserPermissions})
    }
    this.setState({profileEdit:!windowStatus});
    this.getAllUsers();
  }
  /**
   * Generate an updated list of the employees
   */
  getAllUsers = async()=>{
    let allMembersLoaded = await Members.getMembersList();
    this.setState({allMembers:allMembersLoaded})  
  }

  openCloseSettings = () =>{

    let windowStatus = this.state.userSettings;
    this.setState({userSettings:!windowStatus});

  }

   


  componentDidMount(){
    this.getAllUsers();
  }

  render() {

    let userList;

    if(this.state.allMembers.length > 0){
      userList = this.state.allMembers.map((user, index) =>
      <tr key={index}>
        <td>{user.id}</td>
        <td>{user.username}</td>
        <td>{user.userStatus}</td>
        <td>{user.permissions}</td>
        <td><button userid={user.id} userpermissions={user.permissions} username={user.username} onClick={this.openCloseProfileEdit}>Edit</button></td>
      </tr>
      )
    }else{
      userList =
      <tr>
        <td>No user found yet</td>
        <td>Offline</td>
        <td></td>
        <td></td>
      </tr>
    }

    let userSettingsWindow;

    if(this.state.userSettings){
      userSettingsWindow = <UsersSettings close={this.openCloseSettings}/>
    }

    let profileSettingsWindow;

    if(this.state.profileEdit){
      profileSettingsWindow = 
        <EditUser 
          username={this.state.chosenUserName}
          id={this.state.editingUser}
          permissions={this.state.chosenUserPermissions}
          close={this.openCloseProfileEdit}
        />
    }

    return(
      <div>
        {profileSettingsWindow}
        {userSettingsWindow}
      <div className='pop-up' onClick={this.props.close}></div>
      <div className="pop-up-window users-window">
          <div className="row py-3 px-4">
            <div className='container'>
              <h3>All Users</h3>
            </div>
          </div>
          <div className="row p-4">
            <div className='col-12'>
                <div className='wrapper'>
                    <div className="notification-board container-fluid">
                      <table className="table table-light">
                          <thead>
                            <tr>
                              <th>Id</th>
                              <th>Name</th>
                              <th>Status</th>
                              <th>Permissions</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                              {userList}
                          </tbody>
                      </table>
                    </div>
                </div>
            </div>
            <div className='col-12 mt-3 d-flex flex-row-reverse bd-highlight'>
              <button className="" onClick={this.openCloseSettings} type="button">
                <img className='button-icon' src={settingsIcon}></img>
              </button>
            </div>
          </div>
      </div>
    </div>
    );
  }
}

export default AllUsers;